import { Action } from 'redux';

import { IContentInfo } from '../../../../spacesPlatform/models/IContentInfo';
import { Download } from '../../AppActionTypes';
import { isActionFactory } from '../../isActionFactory';

export interface DownloadAction extends Action {
  item: IContentInfo;
}

export function download(item: IContentInfo): DownloadAction {
  return {
    type: Download,
    item
  };
}

export const isDownloadAction = isActionFactory<DownloadAction>(Download);
